import { render, staticRenderFns } from "./CoreNode.vue?vue&type=template&id=05296260&lang=pug"
import script from "./CoreNode.vue?vue&type=script&lang=js"
export * from "./CoreNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports